// Domain
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export class GetInterestRateByFixedTimeService {
  getInterestRate(more_than_one_year: boolean): number {
    return more_than_one_year ? 0.07 : 0.055;
  }
}
